import { render, staticRenderFns } from "./IdentityValidationLoadingOverlay.vue?vue&type=template&id=59e8b55c&scoped=true"
import script from "./IdentityValidationLoadingOverlay.vue?vue&type=script&lang=js"
export * from "./IdentityValidationLoadingOverlay.vue?vue&type=script&lang=js"
import style0 from "./IdentityValidationLoadingOverlay.vue?vue&type=style&index=0&id=59e8b55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8b55c",
  null
  
)

export default component.exports